import { Colors } from '../../../../shared/theme';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  boxButton: {
    padding: '40px 0 0 715px'
  } as React.CSSProperties
};
